export const tourHome = [
  {
    target: '.btn-novo-relatorio',
    content: 'Clique aqui para criar um novo relatório.',
    placement: 'bottom',
  },
  {
    target: '#filtro-data',
    content: 'Use este filtro para ajustar o período.',
    placement: 'right',
  },
  // ...
];